import React from "react";

//images
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import KeyIcon from "@mui/icons-material/Key";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WebhookIcon from "@mui/icons-material/Webhook";
//pages
import OrganizationUsers from "./pages/users";
import MerchantReporting from "./pages/merchant-reporting";
import ApiKeys from "./pages/ApiKeyManagement";
import MerchantPayout from "./pages/merchant-payout";
import Settlements from "./pages/settlements";
import SettingsPage from "./pages/settings";
import PayByLink from "./pages/pay-by-link";
import { PagePermissions } from "./constants/roles";
import Reports from "./pages/reports";
import Webhooks from "./pages/webhooks";

const routes = [
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <PeopleAltIcon size="12px" />,
    route: "/users",
    noCollapse: true,
    component: <OrganizationUsers />,
    permissionsRequired: PagePermissions.OrganizationUsers,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    route: "/transactions",
    icon: <EqualizerIcon size="12px" />,
    noCollapse: true,
    component: <MerchantReporting />,
    permissionsRequired: PagePermissions.MerchantReporting,
  },
  {
    type: "collapse",
    name: "Payout Management",
    key: "payout",
    route: "/payout",
    icon: <TrendingUpRoundedIcon size="12px" />,
    noCollapse: true,
    component: <MerchantPayout />,
    permissionsRequired: PagePermissions.MerchantPayout,
  },
  {
    type: "collapse",
    name: "Settlements",
    key: "settlements",
    route: "/settlements",
    icon: <ReceiptLongIcon size="12px" />,
    noCollapse: true,
    component: <Settlements />,
    permissionsRequired: PagePermissions.Settlements,
  },
  {
    type: "collapse",
    name: "Pay By Link",
    key: "pay-by-link",
    route: "/pay-by-link",
    icon: <InsertLinkIcon size="12px" />,
    noCollapse: true,
    component: <PayByLink />,
    permissionsRequired: PagePermissions.PayByLink,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    route: "/reports",
    icon: <AssessmentIcon size="12px" />,
    noCollapse: true,
    component: <Reports />,
    permissionsRequired: PagePermissions.PayByLink,
  },
  {
    type: "collapse",
    name: "API Key Management",
    key: "api-key",
    route: "/api-key",
    icon: <KeyIcon size="12px" />,
    noCollapse: true,
    component: <ApiKeys />,
    permissionsRequired: PagePermissions.ApiKeys,
  },
  {
    type: "collapse",
    name: "Webhooks",
    key: "webhooks",
    route: "/webhooks",
    icon: <WebhookIcon size="12px" />,
    noCollapse: true,
    component: <Webhooks />,
    permissionsRequired: PagePermissions.Webhooks,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    route: "/settings",
    icon: <SettingsSuggestRoundedIcon size="12px" />,
    noCollapse: true,
    component: <SettingsPage />,
    permissionsRequired: PagePermissions.Settings,
  },
];

export default routes;
